import { get, post } from '../../utils/axios'

export const listTempPayrollAPI = async (body) => {
  return await get('payroll/temp/list', body)
}

export const excelTempPayrollAPI = async (body) => {
  return await get('excel/payroll/temp', body)
}
export const excelTempPrintPayrollAPI = async (body) => {
  return await get('excel/payroll', body)
}

export const syncTempPayrollAPI = async (body) => {
  return await post('payroll/temp/sync', body)
}

export const syncTempPayrollStatusAPI = async (body) => {
  return await post('payroll/temp/sync/status', body)
}

export const printTempPayrollAPI = async (body) => {
  return await post('payroll/temp/print', body)
}

export const listPayrollAPI = async (body) => {
  return await get('payroll/list', body)
}

export const listGroupPayrollAPI = async (body) => {
  return await get('payroll/group/list', body)
}

export const printPayrollAPI = async (body) => {
  return await post('payroll/print', body)
}
